<div [ngClass]="bProcessing?'disabled':''"
    class="d-flex flex-column busy-overlay-parent">    

    <div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
    </div>
    <form #overlayForm="ngForm" class="p-0 m-0">        
    <table class="table table-striped table-bordered table-sm mb-1 w-100">
        <tbody>
            <tr class="small">
                <th class="overlay-header-title text-nowrap text-right p-2" style="width:4em;"><div>
                    <ng-content></ng-content> {{headerTitle}}
                </div></th>
                <td *ngIf="!readonly&&!bEditing; else editCell">
                    <a href="javascript:false;" (click)="onEdit()">
                        {{overlay?.imageId ? (overlay.jpgName||'Edit') : '[+] Add'}}
                    </a>
                    <button *ngIf="!overlay?.imageId && !bProcessing && fallbackOverlay" class="btn btn-secondary btn-sm py-0 px-1 mx-2" 
                        (click)="saveFromFallback()">
                        {{fallbackOverlayCopyTitle}}
                    </button>
                </td>
                <ng-template #editCell>
                <td class="small">
                    <div class="progress form-group" *ngIf="imageUploadProgress > 0">
                        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="imageUploadProgress">
                        </div>
                    </div>
                    <div class="p-0 m-0">
                        <input name="imageFileInput" [(ngModel)]="imageFileName" 
                            #imageFileInput type="file" hidden  accept="image/*" (change)="onImageFileInputChanged($event)">
                        <input name="worldDataFileInput" [(ngModel)]="worldDataFileName" 
                            #worldDataFileInput type="file" hidden  accept=".jgw" (change)="onWorldDataFileInputChanged($event)">
                        <div class="d-flex flex-row">
                            <div>
                                <button *ngIf="!readonly" class="btn btn-path-overlay btn-secondary" 
                                    [disabled]="bImageUploadProcessing" (click)="imageFileInput.click()">
                                    <i class="fa fa-upload"></i>&nbsp;JPG Image
                                </button>                  
                                <div class="text-muted pl-sm-1">{{overlay?.jpgName}}</div>
                            </div>
                            <div>
                                <button *ngIf="!readonly" class="btn btn-path-overlay btn-secondary" 
                                    [disabled]="bWorldDataProcessing" (click)="worldDataFileInput.click()">
                                    <i class="fa fa-upload"></i>&nbsp;JGW Data
                                </button>
                                <div class="text-muted pl-sm-1">{{overlay?.jgwName}}</div>
                            </div>
                            <div *ngIf="!readonly && existingOverlays?.length">
                                <div dropdown [dropup]="true" class="btn-group" placement="top right" [dropup]="true">
                                    <button title="Copy overlay from another path..." 
                                            class="ml-0 px-3 btn btn-path-overlay btn-secondary dropdown-toggle" 
                                            dropdownToggle>
                                    </button>
                                    <ul *dropdownMenu class="p-2 dropdown-menu dropdown-menu-right" role="menu">                      
                                    <li role="menuitem" *ngFor="let existingOverlay of existingOverlays;">
                                        <button class="btn btn-path-overlay btn-secondary d-flex flex-row text-nowrap mb-sm-1 w-100" (click)="copyOverlay(existingOverlay)">
                                            <div>Copy from #{{existingOverlay.ownerIndex+1}}</div>
                                            <div *ngIf="existingOverlay.overlay.jpgName" class="pl-1 small font-italic">
                                                ({{existingOverlay.overlay.jpgName}}, {{existingOverlay.overlay.jgwName}})
                                            </div>
                                        </button>
                                    </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div *ngIf="bEditing" class="d-flex flex-row justify-content-end px-0 py-sm-1">
                                <button (click)="onSave()" [disabled]="!canSave()" class="btn btn-secondary btn-path-overlay">Save</button>
                                <button (click)="onDelete()" [disabled]="bProcessing||overlayForm?.dirty||!overlay" class="btn btn-danger btn-path-overlay">Delete</button>
                                <button (click)="onCancel()" class="btn btn-secondary btn-path-overlay">Cancel</button>
                            </div>
                        </div>
                    </div>
                </td>
                </ng-template>
            </tr>
        </tbody>
    </table>
    </form>
</div>
<div *ngIf="pathTestDoc?.type == 'drive test'" [ngClass]="bProcessingforRoutesoverlay?'disabled':''"
    class="d-flex flex-column busy-overlay-parent">    

    <div *ngIf="bProcessingforRoutesoverlay" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
    </div>
    <form #overlayForm="ngForm" class="p-0 m-0">        
    <table class="table table-striped table-bordered table-sm mb-1 w-100">
        <tbody>
            <tr class="small">
                <th class="text-nowrap text-right p-2" style="width:4em;"><div>Routes</div></th>
                <td *ngIf="!bEditingForRoutes; else editRoutesCell">
                    <a href="javascript:false;" (click)="onEditroutesoverlay()">
                        {{pathTestDoc?.gpx?.routeId ? (pathTestDoc?.gpx?.gpxName||'Edit') : '[+] Add'}}
                    </a>
                </td>
                <ng-template #editRoutesCell>
                <td class="small">
                    <div class="progress form-group" *ngIf="imageUploadProgress > 0">
                        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="imageUploadProgress">
                        </div>
                    </div>
                    <div class="p-0 m-0">
                        <input name="routesGpxFileInput" [(ngModel)]="routesGpxFileName" 
                            #routesGpxFileInput type="file" hidden  accept=".gpx" (change)="onGPXFileInputChanged($event)">
                        <div class="d-flex flex-row">
                            
                            <div>
                                <button class="btn btn-path-overlay btn-secondary" 
                                    [disabled]="bRouteFileProcessing" (click)="routesGpxFileInput.click()">
                                    <i class="fa fa-upload"></i>&nbsp;GPX Files
                                </button>
                                <div *ngIf="!bRouteFileProcessing" class="text-muted pl-sm-1">{{pathTestDoc?.gpx?.gpxName}}</div>
                            </div>
                            <div *ngIf="existingOverlays?.length">
                                <div dropdown [dropup]="true" class="btn-group">
                                    <button title="Copy overlay from another path..." 
                                            class="ml-0 px-3 btn btn-path-overlay btn-secondary dropdown-toggle" 
                                            dropdownToggle>
                                    </button>
                                    <ul *dropdownMenu class="p-2 dropdown-menu" role="menu">                      
                                    <li role="menuitem" *ngFor="let existingOverlay of existingOverlays;">
                                        <button class="btn btn-path-overlay btn-secondary d-flex flex-row text-nowrap mb-sm-1 w-100" (click)="copyOverlay(existingOverlay)">
                                            <div>Copy from #{{existingOverlay.ownerIndex+1}}</div>
                                            <div *ngIf="existingOverlay.overlay.gpxName" class="pl-1 small font-italic">
                                                ({{existingOverlay.overlay.gpxName}})
                                            </div>
                                        </button>
                                    </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div *ngIf="bEditingForRoutes" class="d-flex flex-row justify-content-end px-0 py-sm-1">
                                <button (click)="onSaveGPXRoutes()" [disabled]="!canSaveRoutesgpx()" class="btn btn-secondary btn-path-overlay">Save</button>
                                <button (click)="onDeleteRouteOverlay()" [disabled]="bProcessingforRoutesoverlay||overlayForm?.dirty||!overlay" class="btn btn-danger btn-path-overlay">Delete</button>
                                <button (click)="onCancelroutegpxfile()" class="btn btn-secondary btn-path-overlay">Cancel</button>
                            </div>
                        </div>
                    </div>
                </td>
                </ng-template>
            </tr>
        </tbody>
    </table>
    </form>
</div>

